<div class="public-comment-container">
  <div class="public-comment-content-container">
    <div class="survey-container">
      <h2>Thank you for visiting our virtual public meeting!</h2>
      <p>The comment period is closed.</p>

      <p>
        TDOT will compile and analyze the public comments and post responses on
        the project website along with a summary of the in-person and virtual
        public meeting.
      </p>

      <p>
        These comments will help influence the EA and identify a Recommended
        Preferred Alternative. TDOT plans to host public hearings to present
        these materials in the first half of 2026.
      </p>

      <p>
        Please share your feedback via the project email
        <a href="mailto:TDOT.24ChoiceLanes@tn.gov"
          >TDOT.24ChoiceLanes&#64;tn.gov</a
        >.
      </p>
    </div>
    <p style="margin-bottom: 0">
      Below is a handout with a project overview and other information!
    </p>
    <div class="pdf-grid">
      <app-pdf-viewer
        [pdfUrl]="pdfDocuments[0].url"
        [title]="pdfDocuments[0].title"
        [thumbnailUrl]="pdfDocuments[0].thumbnail"
        containerId="adobe-dc-view-1"
      ></app-pdf-viewer>
    </div>
  </div>

  <div class="public-comment-banner-container">
    <img
      [src]="
        environment.cloudFrontUrl +
        '/content/public-comment/Public+Comment_4.jpg'
      "
      alt=""
      role="presentation"
      class="public-comment-banner"
    />
  </div>
</div>
